import { candidateScopeStatus, finishedMissionStatus, FinishedMissionStatus } from '../../../../../../shared/utils/finished-mission-status';
import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {CandidatesApplied, Mission} from '../../../../../../models/Mission';
import {candidatAccepted, candidateApplied} from '../../../../../../shared/utils/data/shared.data';
import {CandidatStatusOnMission, MissionStatusEnum,} from '../../../../../../shared/utils/enums';
import {isMissionExpired} from '../../../../../../shared/utils/utils.functions';
import {SvgIconComponent} from "angular-svg-icon";
import {SharedModule} from "../../../../../../shared/shared.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {MissionCandidaturesComponent} from "../../mission-candidatures/mission-candidatures.component";

@Component({
  selector: 'app-table-en-cour-action',
  templateUrl: './table-en-cour-action.component.html',
  styleUrl: './table-en-cour-action.component.scss',
  imports: [
    SvgIconComponent,
    SharedModule,
    TooltipModule,
    MissionCandidaturesComponent
  ],
  standalone: true
})
export class TableEnCourActionComponent implements OnInit {
  /** Statut d'une mission TERMINÉE, calculé sur les candidatures actives (voir finished-mission-status.ts). */
  finishedStatus: FinishedMissionStatus = { label: 'Terminée', css: 'required' };

  /** Ligne « un seul professionnel » (liste des missions d'un professionnel côté agence) : statut propre à ce professionnel. */
  candidateScope = false;
  candidateStatus: FinishedMissionStatus = { label: '', css: 'text-secondary' };

  @Input()
  set data(mission : Mission) {
    this._data = mission;
    this.expired = isMissionExpired(this._data.enddate, this._data.endtime);
    this.candidatList = this._data.candidatesApplied;
    this.statusCandidateAccepted = undefined as any;
    this.finishedStatus = finishedMissionStatus(this._data.candidatesApplied);
    const ownStatus = this._data.statusOfCandidatOnMission;
    this.candidateScope = !!ownStatus && ownStatus !== CandidatStatusOnMission.NEUTRAL && !this._data.candidatesApplied?.length;
    if (this.candidateScope) {
      this.candidateStatus = candidateScopeStatus(ownStatus, this.expired, this._data.missionStatus);
    }
    if (candidatAccepted.includes(this._data.statusOfCandidatOnMission) || candidateApplied.includes(this._data.statusOfCandidatOnMission)) {
      this.statusCandidateAccepted = this._data.statusOfCandidatOnMission;
    }
  };

  @Input() column: any


  _data: Mission;
  candidatList: CandidatesApplied[] = [];
  candidatAccepted: CandidatesApplied[] = [];
  indexAcceptedCandidate: number;

  statusCandidateAccepted: CandidatStatusOnMission;
  expired = false;
  loadingContract = false;


  constructor(
  ) {}

  ngOnInit(): void {

  }

  get totallyValidated() {
    if (['VALIDATED', 'INVALIDATED'].includes(this._data.missionStatus)) {
      return this._data?.missionStatus == 'VALIDATED' ? 'Validée' : 'Validation refusée';
    }
    return false;
  }

  // A canceled OFFER (mission-level status CANCELED) reads "Offre de mission annulée".
  get isCanceledOffer(): boolean {
    // Offre annulée = la MISSION est annulée. Une candidature annulée s'affiche comme telle (voir candidateScopeStatus).
    return this._data?.missionStatus === MissionStatusEnum.CANCELED;
  }

  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
  protected readonly MissionStatusEnum = MissionStatusEnum;

  isTotallyAffected() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH);
  }

  isAccepted() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED);
  }

  isContractWaitingToBevalidated() {
    return this._data?.candidatesApplied.some(item => item.statusOfCandidatOnMission === CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION);
  }

}
